import { render, staticRenderFns } from "./tab2.vue?vue&type=template&id=1cd91702&scoped=true"
import script from "./tab2.vue?vue&type=script&lang=js"
export * from "./tab2.vue?vue&type=script&lang=js"
import style0 from "./tab2.vue?vue&type=style&index=0&id=1cd91702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd91702",
  null
  
)

export default component.exports